<div class="vc-modal__innerContainer i18nChoices__modalContent">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>
  <div class="vc-modal__title" i18n="@@PRODUCT.DETAILS.DELIVERY.KNOW_MORE_MODAL.TITLE">Estimated delivery</div>
  <div *ngIf="data" class="vc-modal__content" i18n="@@PRODUCT.DETAILS.DELIVERY.KNOW_MORE_MODAL.CONTENT">
    <p>
      The item is currently at Vestiaire Collective and has successfully passed quality control by our team of
      experts.<br />It will be sent to you on {{ data.sendDay }} from {{ data.warehouse }}.
    </p>
    <p>
      Delivery time is estimated at {{ data.sendDelay }} day(s) to {{ data.pays }} subject to carrier delivery time.
    </p>
  </div>
</div>
